export  function extractFirstParagraph(texts: string[]): string[] {
  if (!texts || !Array.isArray(texts)) {
    return [];
  }
  return texts.map(text => {
    if (!text || typeof text !== 'string') {
      return '';
    }
    const newLineIndex = text.indexOf('\n');
    if (newLineIndex === -1) {
      return text.trim();
    }
    return text.substring(0, newLineIndex).trim();
  });
}

export function extractFirstParagraphFromText(text: string): string {
  if (!text || typeof text !== 'string') {
    return '';
  }

  const newLineIndex = text.indexOf('\n');
  if (newLineIndex === -1) {
    return text.trim();
  }

  return text.substring(0, newLineIndex).trim();
}
